import './FormSubmitButton.css'

function FormSubmitButton({text}) {
  return (
    <button type='submit' className='btn_text btn_border'>{text}</button>
  )
}

export default FormSubmitButton